import Pagination from "react-bootstrap/Pagination";

const Paginator = ({paging, handleCallApi, size}) => {
    paging.size = size;
    const handlePageChange = (page) => {
        paging.page = page;
        handleCallApi();
        window.scrollTo(0, 0);
    };
    const generatePages = () => {
        const totalPages = paging.pages;
        const currentPage = paging.page;

        if (totalPages <= 7) {
            // Mostrar todas las páginas si el total es menor o igual a 7
            return [...Array(totalPages).keys()].map((_, idx) => (
                <Pagination.Item
                    as="button"
                    key={idx + 1}
                    active={idx + 1 === currentPage}
                    onClick={() => handlePageChange(idx + 1)}>
                    {idx + 1}
                </Pagination.Item>
            ));
        }

        const pages = [];
        pages.push(
            <Pagination.Item as="button" key={1} active={currentPage === 1} onClick={() => handlePageChange(1)}>
                1
            </Pagination.Item>,
        );

        if (currentPage > 4) {
            pages.push(<Pagination.Ellipsis key="start-ellipsis" disabled />);
        }

        const startPage = Math.max(2, currentPage - 2);
        const endPage = Math.min(totalPages - 1, currentPage + 2);

        for (let i = startPage; i <= endPage; i++) {
            pages.push(
                <Pagination.Item as="button" key={i} active={i === currentPage} onClick={() => handlePageChange(i)}>
                    {i}
                </Pagination.Item>,
            );
        }

        if (currentPage < totalPages - 3) {
            pages.push(<Pagination.Ellipsis key="end-ellipsis" disabled />);
        }

        pages.push(
            <Pagination.Item
                as="button"
                key={totalPages}
                active={currentPage === totalPages}
                onClick={() => handlePageChange(totalPages)}>
                {totalPages}
            </Pagination.Item>,
        );

        return pages;
    };

    return paging.pages <= 1 ? (
        <div className="d-flex align-items-center">
            <input
                type="size"
                className="form-control text-end ms-2"
                defaultValue={paging.size}
                title="Elementos por página"
                disabled={true}
                style={{maxWidth: "46px"}}
            />
        </div>
    ) : (
        <div className="d-flex align-items-center">
            <Pagination className="mb-0 bg-transparent">
                <Pagination.First
                    as="button"
                    onClick={() => handlePageChange(1)}
                    disabled={paging.pages === 1 || paging.page === 1}
                />
                <Pagination.Prev as="button" onClick={() => handlePageChange(paging.page - 1)} disabled={paging.page === 1} />

                {generatePages()}

                <Pagination.Next
                    as="button"
                    onClick={() => handlePageChange(paging.page + 1)}
                    disabled={paging.page === paging.pages}
                />
                <Pagination.Last
                    as="button"
                    onClick={() => handlePageChange(paging.pages)}
                    disabled={paging.page === paging.pages}
                />
            </Pagination>

            <input
                type="size"
                className="form-control ms-2 text-end"
                defaultValue={paging.size}
                title="Elementos por página"
                disabled={true}
                style={{maxWidth: "46px"}}
            />
        </div>
    );
};
export default Paginator;
